"use strict";
/**
 * Kit-Compatible Signer Types
 *
 * Framework-agnostic signer interfaces that match @solana/signers specification.
 * These types enable seamless integration with @solana/kit without external dependencies.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMessageModifyingSigner = isMessageModifyingSigner;
exports.isTransactionSendingSigner = isTransactionSendingSigner;
/**
 * Type guard to check if a value is a MessageModifyingSigner
 */
function isMessageModifyingSigner(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'address' in value &&
        'modifyAndSignMessages' in value &&
        typeof value.modifyAndSignMessages === 'function');
}
/**
 * Type guard to check if a value is a TransactionSendingSigner
 */
function isTransactionSendingSigner(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'address' in value &&
        'signAndSendTransactions' in value &&
        typeof value.signAndSendTransactions === 'function');
}
